<template>
  <el-header>
    <el-row :gutter="24" id="aaaa">
      <el-col :span="24">
        <div class="grid-content bg-purple">
          <el-menu :default-active="this.$route.path" class="el-menu-demo ff" router mode="horizontal"
            @select="handleSelect" background-color="#373f50" text-color="#fff" active-text-color="#ffd04b">
            <el-menu-item v-for="(item, i) in navList1" :key="i" :index="item.name">
              <template slot="title">
                <span> {{ item.navItem }}</span>
              </template>
            </el-menu-item>
          </el-menu>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="24">

    </el-row>

  </el-header>
</template>

<script>
export default {
  name: "TopBar",
  data() {
    return {

    };
  },
  computed: {
    navList1: function () {
      return [
        { name: "/", navItem: this.$t('router.homePage') },
        { name: "/aboutUs", navItem: this.$t('router.about') },
        { name: "/news", navItem: this.$t('router.news') },
        { name: "/showProduct", navItem: this.$t('router.product') },
        { name: "/Cooperative", navItem: this.$t('router.cooperation') },
        { name: "/contactUs", navItem: this.$t('router.contact') },

      ]
    }
  },
  methods: {
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
  },
};
</script>

<style lang="less" scoped>
// .el-menu-demo:first-child{
//   padding-left: 50px;
// }

/deep/ #aaaa {
  margin: 0px !important;

  .el-col {
    padding: 0px !important;
  }
}

/deep/ .grid-content .ff {
  display: flex;
  justify-content: space-evenly;
}

/deep/ .el-menu.el-menu--horizontal {
  border-bottom: none;
}
</style>